export enum BidAttachmentType {
  LEGAL_ATTESTATION = 'LEGAL_ATTESTATION',
  BUSINESS_ATTACHMENT = 'BUSINESS_ATTACHMENT'
}
